
class AnnonceUtils {
  isBoostStillValid(boostEndDate){
    if(boostEndDate === undefined || boostEndDate === null){
      return false
    }

    let now = Date.now()
    return now <= boostEndDate
  }
}

export default new AnnonceUtils()



// WEBPACK FOOTER //
// ./src/utils/AnnonceUtils.js